<template>
    <div v-if="isLastError" class="error-block">
        <div class="error-title">Последняя ошибка {{timeFromErrorFormatted}} назад:</div>
        <div>{{errorText}}</div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import moment from 'moment';


    export default {
        name: "LastErrorBlock",
        computed: {
            ...mapState('app', {
                lastError: 'lastError',
            }),
            isLastError() {
                return this.lastError !== null;
            },
            timeFromErrorFormatted() {
                if(this.timeFromError < 60) {
                    return `${this.timeFromError} сек`;
                }

                return `${Math.round(this.timeFromError / 60)} мин`;
            },
            errorText() {
                return this.lastError.error;
            },
        },
        methods: {
            startUpdateInterval() {
                this.clearUpdateInterval();

                this.updateInterval = setInterval(() => {
                    this.timeFromError = this.isLastError
                        ? moment().diff(this.lastError.moment, 'seconds')
                        : 0;
                }, 500);
            },
            clearUpdateInterval() {
                if(!this.updateInterval) {
                    return;
                }

                clearInterval(this.updateInterval);
            },
        },
        data() {
            return {
                updateInterval: null,
                timeFromError: 0,
            };
        },
        mounted() {
            this.startUpdateInterval();
        },
        destroyed() {
            this.clearUpdateInterval();
        },
    }
</script>

<style scoped>
    .error-block {
        color: red;
        line-height: 1;
        margin: 15px 10px;
        font-size: 0.9em;
    }
    .error-title {
        /*text-decoration: underline;*/
        font-weight: bold;
    }
</style>